import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import React from 'react';

const LoginPage = lazy(() => import('../pages/login/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Clients = lazy(() => import('../pages/clients/page'));
const Factures = lazy(() => import('../pages/factures/page'));
const Rebours = lazy(() => import('../pages/rebours/page'));
const Devis = lazy(() => import('../pages/devis/page'));
const Statistiques = lazy(() => import('../pages/statistiques/page'));
const Parametres = lazy(() => import('../pages/parametres/page'));

function AuthGuard({ children }: { children: React.ReactNode }) {
  const isAuth = sessionStorage.getItem('readyia_auth') === 'true';
  if (!isAuth) {
    // Redirect unauthenticated users to the login page
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />
  },
  {
    path: '/dashboard',
    element: (
      <AuthGuard>
        <Dashboard />
      </AuthGuard>
    )
  },
  {
    path: '/clients',
    element: (
      <AuthGuard>
        <Clients />
      </AuthGuard>
    )
  },
  {
    path: '/factures',
    element: (
      <AuthGuard>
        <Factures />
      </AuthGuard>
    )
  },
  {
    path: '/rebours',
    element: (
      <AuthGuard>
        <Rebours />
      </AuthGuard>
    )
  },
  {
    path: '/devis',
    element: (
      <AuthGuard>
        <Devis />
      </AuthGuard>
    )
  },
  {
    path: '/charges',
    element: (
      <AuthGuard>
        {React.createElement(React.lazy(() => import('../pages/charges/page')))}
      </AuthGuard>
    )
  },
  {
    path: '/statistiques',
    element: (
      <AuthGuard>
        <Statistiques />
      </AuthGuard>
    )
  },
  {
    path: '/parametres',
    element: (
      <AuthGuard>
        <Parametres />
      </AuthGuard>
    )
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
